import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { PERIODS } from './reportingFilters';
import messages from '../../../locale/jsonMessages';
import s from './OwnerReporting.css';

const PERIOD_LABELS = {
  today: 'orpPeriodToday', '7d': 'orpPeriod7d', '30d': 'orpPeriod30d', year: 'orpPeriodYear', custom: 'orpPeriodCustom',
};

// Period buttons (+ custom dates) and vehicle list. Controlled by the URL state: it only calls onChange(patch).
// vehicles: [{ id, title }] ; the custom dates are applied with the button (end >= start required, the server limits to 366 days).
const PeriodFilter = ({ period, startDate, endDate, listId, vehicles = [], onChange }) => {
  const { formatMessage } = useIntl();
  const [customOpen, setCustomOpen] = useState(period === 'custom');
  const [draftStart, setDraftStart] = useState(startDate || '');
  const [draftEnd, setDraftEnd] = useState(endDate || '');

  useEffect(() => { setDraftStart(startDate || ''); setDraftEnd(endDate || ''); }, [startDate, endDate]);
  useEffect(() => { if (period === 'custom') setCustomOpen(true); }, [period]);

  const customValid = Boolean(draftStart) && Boolean(draftEnd) && draftEnd >= draftStart;

  const choose = (value) => {
    if (value === 'custom') { setCustomOpen(true); return; }
    setCustomOpen(false);
    if (value !== period) onChange({ period: value });
  };

  return (
    <div className={s.filters}>
      <div className={s.segmented} role="group" aria-label={formatMessage(messages.orpPeriodLabel)}>
        {PERIODS.map((value) => (
          <button key={value} type="button" aria-pressed={period === value}
            className={cx(s.segment, period === value && s.segmentActive)} onClick={() => choose(value)}>
            {formatMessage(messages[PERIOD_LABELS[value]])}
          </button>
        ))}
      </div>
      <select className={s.select} aria-label={formatMessage(messages.orpVehicleLabel)} value={listId || ''}
        onChange={(event) => onChange({ listId: event.target.value ? Number(event.target.value) : null })}>
        <option value="">{formatMessage(messages.orpAllVehicles)}</option>
        {vehicles.map((vehicle) => <option key={vehicle.id} value={vehicle.id}>{vehicle.title}</option>)}
      </select>
      {customOpen && (
        <div className={s.customPanel}>
          <label className={s.field}>{formatMessage(messages.orpDateFrom)}
            <input type="date" className={s.dateInput} value={draftStart} max={draftEnd || undefined}
              onChange={(event) => setDraftStart(event.target.value)} />
          </label>
          <label className={s.field}>{formatMessage(messages.orpDateTo)}
            <input type="date" className={s.dateInput} value={draftEnd} min={draftStart || undefined}
              onChange={(event) => setDraftEnd(event.target.value)} />
          </label>
          <button type="button" className={s.primaryButton} disabled={!customValid}
            onClick={() => onChange({ period: 'custom', startDate: draftStart, endDate: draftEnd })}>
            {formatMessage(messages.orpApply)}
          </button>
        </div>
      )}
    </div>
  );
};

export default withStyles(s)(PeriodFilter);
